import { BrowserRouter, Route, Routes } from "react-router-dom";
import SigninForm from "../Components/auth/SigninForm.jsx";
import AuthLayout from "../layouts/AuthLayout";
import DashboardLayout from "../layouts/DashboardLayout";
import ProtectedRoutes from "../navigation/ProtectedRoutes";
import PublicRoutes from "../navigation/PublicRoutes";
// import DashboardPage from "../Pages/DashboardPage";
import CCQueryManagementScreen from "../Pages/CCQueryManagement/CCQueryManagementScreen.jsx";
import StatsScreen from "../Pages/Game/GameScreen.jsx";
import GameStatsScreen from "../Pages/Game/GameStatsScreen.jsx";
import SubGameScreen from "../Pages/Game/SubGameScreen.jsx";
import Message from "../Pages/Messages.jsx";
import NotFound from "../Pages/NotFound.jsx";
import Setting from "../Pages/Setting/index.jsx";
import TransactionManagementScreen from "../Pages/TransactionManagement/TransactionManagementScreen.jsx";
import UserManagementScreen from "../Pages/UserManagement/UserManagementScreen.jsx";
import SubGameStatsScreen from "../Pages/Game/SubGameStatsScreen.jsx";
import GameUsersStatsScreen from "../Pages/Game/GameUsersStatsScreen.jsx";
import SubGameUsersStatsScreen from "../Pages/Game/SubGameUsersStatsScreen.jsx";
import SendPushNotifications from "../Pages/SendPushNotification.jsx";

const Navigation = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route element={<PublicRoutes />}>
          <Route path="/" element={<AuthLayout children={<SigninForm />} />} />
        </Route>

        {/* PROTECTED ROUTES */}
        <Route element={<ProtectedRoutes />}>
          {/* <Route
            path="/admin/dashboard"
            element={<DashboardLayout children={<DashboardPage />} />}
          />

         <Route
            path="/admin/dashboard"
            element={<DashboardLayout children={<DashboardPage />} />}
          />
          <Route
            path="/admin/orders"
            element={<DashboardLayout children={<OrderPage />} />}
          />
          <Route
            path="/admin/customers"
            element={<DashboardLayout children={<CustomerPage />} />}
          />
          <Route
            path="/admin/distributors"
            element={<DashboardLayout children={<DistributorsPage />} />}
          />
          <Route
            path="/admin/shopowners"
            element={<DashboardLayout children={<ShopOwnerPage />} />}
          />
          <Route
            path="/admin/riders"
            element={<DashboardLayout children={<RidersPage />} />}
          />

          <Route
            path="/admin/user"
            element={<DashboardLayout children={<UserPage />} />}
          />
          <Route
            path="/admin/change-password"
            element={<DashboardLayout children={<ChangePasswordPage />} />}
          />
          <Route
            path="/admin/page/:slug"
            element={<DashboardLayout children={<ContentManagementPage />} />}
          />
          <Route
            path="/admin/faqs"
            element={<DashboardLayout children={<Faqs />} />}
          />
          <Route
            path="/admin/report-types"
            element={<DashboardLayout children={<ReportTypes />} />}
          />
          <Route
            path="/admin/reports"
            element={<DashboardLayout children={<ReportsPage />} />}
          /> */}
          <Route
            path="/admin/user-management"
            element={<DashboardLayout children={<UserManagementScreen />} />}
          />
          <Route
            path="/admin/game"
            element={<DashboardLayout children={<StatsScreen />} />}
          />
          <Route
            path="/admin/game/slot-machine"
            element={<DashboardLayout children={<SubGameScreen />} />}
          />
          <Route
            path="/admin/game/:slug/stats"
            element={<DashboardLayout children={<GameStatsScreen />} />}
          />
          <Route
            path="/admin/game/:slug/user/stats"
            element={<DashboardLayout children={<GameUsersStatsScreen />} />}
          />
          <Route
            path="/admin/game/slot-machine/:slug/user/stats"
            element={<DashboardLayout children={<SubGameUsersStatsScreen />} />}
          />
          <Route
            path="/admin/game/slot-machine/:theme_slug/stats"
            element={<DashboardLayout children={<SubGameStatsScreen />} />}
          />
          <Route
            path="/admin/cc-query-management"
            element={<DashboardLayout children={<CCQueryManagementScreen />} />}
          />
          <Route
            path="/admin/transaction"
            element={<DashboardLayout children={<TransactionManagementScreen />} />}
          />
          <Route
            path="/admin/chat-support"
            element={<DashboardLayout children={<Message />} />}
          />
          <Route
            path="/admin/push-notifications"
            element={<DashboardLayout children={<SendPushNotifications />} />}
          />
          <Route
            path="/admin/settings"
            element={<DashboardLayout children={<Setting />} />}
          />
        </Route>
        {/* KEEP IT AT THE END */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Navigation;
